import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { BrowserRouter as Router, Switch, Route, Redirect, withRouter }  from 'react-router-dom';
import { PropTypes } from 'prop-types';

class GAListener extends React.Component {
  
    componentDidMount() {
      this.sendPageView(this.props.history.location);
      this.props.history.listen(this.sendPageView);
    }
  
    sendPageView(location) {
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
    }
  
    render() {
      return this.props.children;
    }
}

export default withRouter(GAListener);
